import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as HooksApolloProvider } from '@apollo/react-hooks';
import { ApolloClient } from 'apollo-boost';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import config from './config';
import history from './history';

import App from './App';

import './i18n';
import 'moment/locale/es';

import configureStore from './store/store';
import PageLoader from './components/Common/PageLoader';

const store = configureStore();

const httpLink = new HttpLink({
  uri: config.apiUrl.concat('graphql')
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('SHERPA_AUTH_JWT_ID');
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const logoutLink = onError(({ networkError }) => {
  // GraphQLController ahora manda los errores de dominio como {data, errors} con status 200
  // (antes iban en un 400 mal formado, asi que networkError siempre existia aqui). Con errores
  // que solo traen graphQLErrors, networkError llega undefined -- sin este chequeo tronaba.
  if (networkError && networkError.statusCode === 401) {
    history.push('/login');
  }
});

const client = new ApolloClient({
  link: authLink.concat(logoutLink.concat(httpLink)),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    },
    watchQuery: {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  }
});

ReactDOM.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <HooksApolloProvider client={client}>
        <Suspense fallback={<PageLoader />}>
          <App />
        </Suspense>
      </HooksApolloProvider>
    </ApolloProvider>
  </Provider>,
  document.getElementById('app')
);
